import $ from 'jquery';

import * as toast from 'stdjs/toast';

export function displayMessages(errorMessages, warningMessages, infoMessages, successMessages = [], defaultMessages = []) {

    if (typeof errorMessages !== "undefined" && errorMessages.length > 0) {

        for (var i = 0; i < errorMessages.length; i++) {
            toast.showErrorMessage(errorMessages[i], true );
        }

    }

    if (typeof warningMessages !== "undefined" && warningMessages.length > 0) {

        for (var i = 0; i < warningMessages.length; i++) {
            toast.showWarningMessage(warningMessages[i]);
        }

    }
    
    // TODO success message
    if (typeof infoMessages !== "undefined" && infoMessages.length > 0) {
        
        for (var i = 0; i < infoMessages.length; i++) {
            toast.showInfoMessage(infoMessages[i]);
        }

    }
    
    if (typeof successMessages !== "undefined" && successMessages && successMessages.length > 0) {
        
        for (var i = 0; i < successMessages.length; i++) {
            toast.showSuccessMessage(successMessages[i]);
        }

    }
    
    if (typeof defaultMessages !== "undefined" && defaultMessages && defaultMessages.length > 0) {
        
        for (var i = 0; i < defaultMessages.length; i++) {
            toast.showDefaultMessage(defaultMessages[i]);
        }

    }
    
}

export function destroyMessages() {
    toast.destroyMessages();
}


export function displayFieldHighlights(errorFieldHighlights, warningFieldHighlights, infoFieldHighlights, $context = null) {
    
    destroyFieldHighlights();
    
    if ( $context == null ){
        $context = $( "body" );
    }
    
    if (typeof errorFieldHighlights !== "undefined" && errorFieldHighlights.length > 0) {

        for (var i = 0; i < errorFieldHighlights.length; i++) {
            $("label[for='" + errorFieldHighlights[i] + "']", $context ).addClass("formError error");
            $(".iconInput." + errorFieldHighlights[i], $context).addClass("formError error");
        }

    }

    if (typeof warningFieldHighlights !== "undefined" && warningFieldHighlights.length > 0) {

        for (var i = 0; i < warningFieldHighlights.length; i++) {
            $("label[for='" + warningFieldHighlights[i] + "']").addClass("formWarning warning");
        }

    }

    if (typeof infoFieldHighlights !== "undefined" && infoFieldHighlights.length > 0) {
        
        for (var i = 0; i < infoFieldHighlights.length; i++) {
            $("label[for='" + infoFieldHighlights[i] + "']").addClass("formInfo info");
        }

    }
    
}

export function destroyFieldHighlights() {
    $("label").removeClass("formError formWarning formInfo error warning info");
    $(".iconInput").removeClass("formError formWarning formInfo error warning info");
}
